import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';
import { Checkbox } from 'primereact/checkbox';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioCancelacion from '../servicios/ServicioCancelacion';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import servicioSerie from '../servicios/ServicioSerie';
import { Dialog } from 'primereact/dialog';
export class Cancelacion extends Component {
    constructor() {
        super();
        this.state = {
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            criterio: {},
            muestraFecha: 'none',
            muestraFolio: 'none',
            muestraRfc: 'none',
            muestraBoton: 'none',
            muestraNumeroFolio: 'none',
            tipoCriterio: [
                { label: 'Fecha Creación', value: 'fecha' },
                { label: 'RFC Receptor', value: 'rfc' },
                { label: 'Folio Fiscal', value: 'folioFiscal' },
                { label: 'Folio y Serie', value: 'folio' },
            ],
            tipSeleccionado: null,
            cfdis: [],
            series: [],
            modalCancelar: false,
            mostrarModalResultado: false,
            listaResultados: [],
            mostrarModalRexpedicion: false,
            tcReceptor: {},
            erroresRequeridos: {},
            comprobante: {},
            enviarReexPedicion: {},
            urlDescargaArchivosFacturacion: 'documentos/descargarzip.json',
            urlDescargaArchivosCancelacion: 'documentos/descargarzipAcuseCancelacion.json',
            restriccionSesion: [],
            cancelacionDto:{},
            motivos: [
                { value: "01", label: "Comprobante emitido con errores con relación" }, 
                { value: "02", label: "Comprobante emitido con errores sin relación" },
                { value: "03", label: "No se llevó a cabo la operación " },
                { value: "04", label: "Operación nominativa relacionada en una factura global" }
            ]

        }
    }
    componentDidMount() {
        servicioSerie.mostrar().then((response) => {
            this.setState({ series: response.data.lista });
        }).catch((error) => {
        });

    }

    agregarRestriccionSesion = () => {
        let { paginacion, restriccionSesion } = this.state;
        console.log(restriccionSesion)
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restriccionSesion)) {
            paginacion.restriccionesDinamicas = restriccionSesion;
        }
    }

    obtenerResultados = () => {
        this.agregarRestriccionSesion();
        const { paginacion } = this.state;
        servicioCfdi.paginacion_admin(paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        });
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerResultados();
    }
    buscarPorFechas = () => {
        let { paginacion, criterio, restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioFecha(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
                valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(criterio.fechaInicial) + " 00:00:00",
                fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(criterio.fechaFinal) + " 23:59:59"
            }];
            restriccionSesion = paginacion.restriccionesDinamicas;
            this.setState({ paginacion: paginacion, restriccionSesion });
            this.obtenerResultados();
        }
    }
    buscarPorRfc = () => {
        let { paginacion, criterio, restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioRfcReceptor(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq", nombrePropiedad: "alias_tcReceptor.rfc",
                valorPropiedad: criterio.rfc
            }];
            restriccionSesion = paginacion.restriccionesDinamicas;
            this.setState({ paginacion: paginacion, restriccionSesion });
            this.obtenerResultados();
        }
    }
    validarFormularioRfcReceptor = (criterio) => {
        const errores = {};
        let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

        if (!patron.test(criterio.rfc)) {
            this.growl.show({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física AAAA010101AAA, Persona Moral AAA010101AAA' });
            errores.rfc = "El rfc es inválido";
        }
        return errores;
    }
    validarFormularioFecha = (criterio) => {

        const errores = {};
        if (!criterio.fechaInicial)
            errores.fechaInicial = "El campo requerido";

        if (!criterio.fechaFinal)
            errores.fechaFinal = 'El campo es requerido'

        if (criterio.fechaInicial !== undefined && criterio.fechaInicial !== null)
            if (criterio.fechaInicial.length > 0 && new Date(criterio.fechaInicial).toString() === 'Invalid Date')
                errores.fechaInicial = "Fecha inválida";
        if (criterio.fechaFinal !== undefined && criterio.fechaFinal !== null)
            if (criterio.fechaFinal.length > 0 && new Date(criterio.fechaFinal).toString() === 'Invalid Date')
                errores.fechaFinal = "Fecha inválida";

        return errores;
    }
    validarFormularioFolioFiscal = (criterio) => {
        const errores = {};
        if (!criterio.folio)
            errores.folio = "El campo requerido";

        return errores;
    }
    validarFormularioFolioNumero = (criterio) => {
        const errores = {};
        if (!criterio.folio)
            errores.folio = "El campo requerido";
        if (!criterio.serie)
            errores.serie = "El campo requerido";

        return errores;
    }

    buscarPorFolio = () => {
        let { paginacion, criterio, restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioFolioFiscal(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.uuid",
                valorPropiedad: criterio.folio
            }];
            restriccionSesion = paginacion.restriccionesDinamicas;
            this.setState({ paginacion: paginacion, restriccionSesion });
            this.obtenerResultados();
        }
    }
    buscarPorNumeroFolio = () => {
        let { paginacion, criterio, restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioFolioNumero(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.folio",
                valorPropiedad: criterio.folio
            }, {
                tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.serie",
                valorPropiedad: criterio.serie.nombre
            }];

            restriccionSesion = paginacion.restriccionesDinamicas;
            this.setState({ paginacion: paginacion, restriccionSesion });
            this.obtenerResultados();
        }
    }
    mostrarDivs(event) {
        this.setState({ tipSeleccionado: event.value, muestraBoton: 'block', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {}, restriccionSesion: [] });

        if (event.value === 'folioFiscal')
            this.setState({ muestraNumeroFolio: 'none', muestraFecha: 'none', muestraFolio: 'block', muestraRfc: 'none', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });

        if (event.value === 'fecha')
            this.setState({ muestraNumeroFolio: 'none', muestraFecha: 'block', muestraFolio: 'none', muestraRfc: 'none', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });

        if (event.value === 'rfc')
            this.setState({ muestraNumeroFolio: 'none', muestraFecha: 'none', muestraFolio: 'none', muestraRfc: 'block', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });

        if (event.value === 'folio')
            this.setState({ muestraRfc: 'none', muestraNumeroFolio: 'block', muestraFecha: 'none', muestraFolio: 'none', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });
    }
    columnaTotal = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.total)}</div>;
    }


    columnaFechaCreacion = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.ttCfdi.fechaCreacion)}</div>;
    }

    columnaEstatus = (rowData, column) => {
        if (rowData.ttCfdi.estado === 1)
            return <p>Activo</p>
        if (rowData.ttCfdi.estado === 2)
            return <p>Cancelado</p>
        if (rowData.ttCfdi.estado === 3)
            return <p>Cancelado/Nota de Credito</p>
        if (rowData.ttCfdi.estado === 4)
            return <p>Reexpedido</p>
    }

    columnaTipoComprobante = (rowData, column) => {
        if (rowData.ttCfdi.tipoFactura === 0)
            return <p>Factura de pagos</p>
        if (rowData.ttCfdi.tipoFactura === 1)
            return <p>Factura de emergencia</p>
        if (rowData.ttCfdi.tipoFactura === 2)
            return <p>Factura de Peaje</p>
        if (rowData.ttCfdi.tipoFactura === 3)
            return <p>Factura reexpedida</p>
        if (rowData.ttCfdi.tipoFactura === 4)
            return <p>Ingresos diversos</p>
        if (rowData.ttCfdi.tipoFactura === 5)
            return <p>Ingresos diversos/Nota de crédito</p>
        if (rowData.ttCfdi.tipoFactura === 6)
            return <p>Nota de crédito</p>

    }
    asignarValores = (event) => {
        if (event.target.id === 'rfc' || event.target.id === 'folio')
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        else
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }
    columnaCancelarVariosCfdis = (rowData, column) => {
        return <div>
            {rowData.ttCfdi.estado === 1 ?
                <Checkbox inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)}></Checkbox>
                : null}
        </div>;
    }
    columnaReexpedicion = (rowData, column) => {


        return <div>
            {rowData.ttCfdi.estado === 3 ?
                <Button label="Reexpedición" onClick={(e) => this.mostrarRexpedicion(column.rowData)} className="teal-btn flat-btn" />
                : null}
        </div>;

    }

    mostrarRexpedicion(objeto) {
        this.setState({ mostrarModalRexpedicion: true, comprobante: objeto });
    }

    agregar = () => {
        this.setState({ modalCancelar: false });
    }
    cerrarModalCancelacion = () => {
        this.setState({ modalCancelar: false, cfdis: [] });
    }
    enviarCancelar = () => {
        let { cancelacionDto } = this.state;
        let errores=this.validarFormulario(cancelacionDto);
        this.setState({errores});
        if(servicioAsignacionValoresObjetos.esObjetoVacio(errores)){
            servicioCancelacion.cancelar_cfdis(cancelacionDto).then((response) => {
                this.setState({ listaResultados: response.data.lista, mostrarModalResultado: true, modalCancelar: false, cfdis: [] });
                this.obtenerResultados();
            }).catch((error) => {
                if (error)
                    return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }
        
    }
    
    validarFormulario = (cancelacionDto) => {
        let errores = {};
        if (servicioAsignacionValoresObjetos.esObjetoVacio(cancelacionDto.motivo)) {
            errores.motivo = "Debe de elegir un motivo de cancelacion";
        } else {
            if (cancelacionDto.motivo === "01" && servicioAsignacionValoresObjetos.esObjetoVacio(cancelacionDto.folioSustitucion)) {
                errores.folioSustitucion = "Debe de agregar un folio de sustitución para cancelar la factura";
            }
        }
        return errores;
    }


    enviarExpedir = () => {
        let { comprobante, tcReceptor, enviarReexPedicion } = this.state;
        const validacion = this.validarFormularioReexpedir(tcReceptor);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            enviarReexPedicion.cfdi = comprobante;
            enviarReexPedicion.receptor = tcReceptor;
            servicioCancelacion.reexpedir_cfdis(enviarReexPedicion).then((response) => {

                if (response.data.error === false) {
                    this.setState({ listaResultados: response.data.lista, mostrarModalResultado: true, mostrarModalRexpedicion: false, cfdis: [], comprobante: {}, tcReceptor: {} });
                    this.obtenerResultados();
                }
            }).catch((error) => {
                if (error)
                    return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });

        }
    }
    validarFormularioReexpedir = (objeto) => {
        const errores = {};
        if (!objeto.nombre)
            errores.nombre = "El campo es requerido";
        if (!objeto.rfc)
            errores.rfc = "El campo es requerido";

        return errores;
    }

    asignarCfdis(e) {        
        let cancelacionDto={};
        if (e.checked) {
            cancelacionDto.uuid=e.value.ttCfdi.uuid;            
            this.setState({ modalCancelar: true});
        }
        this.setState({ cancelacionDto ,errores:{}});
    }
    cerrarModalResultados = () => {
        this.setState({ mostrarModalResultado: false });
    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);

    }
    templateDescargaArchivos = (rowData, column) => {
        return <div>
            <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
        </div>;
    }
    descargaArchivos = (rowData) => {
        let { urlDescargaArchivosFacturacion, urlDescargaArchivosCancelacion } = this.state;
        if (rowData.serie === "Cancelado") {
            servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosCancelacion, { id: rowData.busqueda });
        } else {
            servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosFacturacion, { id: rowData.busqueda });
        }
    }

    templateMotivos = (option) => {
        return (
            <div className="p-clearfix">                
                <span>{option.value}-{option.label}</span>
            </div>
        );
    }

    render() {
        let { series, erroresRequeridos, tcReceptor, listaResultados, errores, criterio,
             paginacion, inicio, muestraFecha, muestraFolio, muestraRfc, tipoCriterio, mostrarModalResultado,
              mostrarModalRexpedicion, muestraNumeroFolio,modalCancelar, cancelacionDto, motivos } = this.state;

        const piePaginaModalRestultados = (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
            </div>
        );
        const dialogFooterExpedir = (
            <div>
                <Button icon="pi-md-check" onClick={this.enviarExpedir} label="Expedir" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ tcReceptor: {}, mostrarModalRexpedicion: false, erroresRequeridos: {} })} label="Salir" className="p-button-danger flat-btn" />
            </div>
        );

        return (

            <div className="content-section implementation">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">

                    <h1 style={{ marginBottom: '30px' }}>Cancelación y Reexpedición de Facturas (CFDI)</h1>
                    <div className="p-grid  p-fluid">

                        <div className="p-col-12 p-md-12">
                            <Dropdown value={this.state.tipSeleccionado} options={tipoCriterio} style={{ width: '50%' }}
                                onChange={this.mostrarDivs.bind(this)} placeholder="Selecciona un criterio de busqueda" />
                            <br /><br />
                        </div>
                    </div>
                    <div style={{ display: muestraFecha, marginBottom: '-50px' }}>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-2" style={{ textAlign: 'center', alignSelf: 'center' }}>
                                <label htmlFor="fechaInicial">* Fecha Inicial:</label>
                            </div>
                            <div className="p-col-12 p-md-3" style={{ alignSelf: 'center' }}>
                                <Calendar id="fechaInicial" name="criterio.fechaInicial" className={errores.fechaInicial ? 'p-error' : ''} value={criterio.fechaInicial || ''} locale={servicioIdioma} onChange={this.asignarValores} showIcon={true} dateFormat="yy-mm-dd" />
                                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-2" style={{ textAlign: 'center', alignSelf: 'center' }}>
                                <label htmlFor="fechaFinal">* Fecha Final:</label>
                            </div>
                            <div className="p-col-12 p-md-3" style={{ alignSelf: 'center' }}>
                                <Calendar id="fechaFinal" name="criterio.fechaFinal" className={errores.fechaFinal ? 'p-error' : ''} value={criterio.fechaFinal || ''} locale={servicioIdioma} onChange={this.asignarValores} showIcon={true} dateFormat="yy-mm-dd" />
                                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2" style={{ padding: '30px' }}>
                                <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorFechas} />

                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12" style={{ marginTop: '20px', marginBottom: '-70px', marginLeft: '20px' }}>
                        <div style={{ display: muestraFolio }}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">description</i></span>
                                        <InputText placeholder="UUID" maxLength={38} id="folio" name="criterio.folio" className={errores.folio ? 'p-error' : ''} value={criterio.folio || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.folio ? <div><br /> <Message severity="error" text={errores.folio} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-3">

                                    <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorFolio} />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12" style={{ marginTop: '50px', marginBottom: '20px' }}>
                        <div style={{ display: muestraNumeroFolio }}>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">

                                        <span className="p-inputgroup-addon"><i className="material-icons">description</i></span>
                                        <InputText placeholder="Folio" maxLength={38} id="folio" name="criterio.folio" className={errores.folio ? 'p-error' : ''} value={criterio.folio || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.folio ? <div><br /> <Message severity="error" text={errores.folio} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">

                                        <span className="p-inputgroup-addon"><i className="material-icons">description</i></span>
                                        <Dropdown dataKey="id" placeholder="Selecciona una Serie" id="serie" name="criterio.serie" options={series} value={criterio.serie} onChange={this.asignarValoresObjeto} optionLabel="nombre" className={errores.serie ? 'p-error' : ''} />

                                    </div>
                                    {errores.serie ? <div><br /> <Message severity="error" text={errores.serie} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorNumeroFolio} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12" style={{ marginTop: '-30px', marginLeft: '20px' }}>
                        <div style={{ display: muestraRfc }}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">person</i></span>
                                        <InputText placeholder="RFC" maxLength={13} id="rfc" name="criterio.rfc" className={errores.rfc ? 'p-error' : ''} value={criterio.rfc || ''}
                                            onChange={this.asignarValores} style={{ width: '100%' }} />
                                    </div>
                                    {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorRfc} />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px" responsive={true} header="MIS FACTURAS DE PEAJE">
                    <Column header="Cancelar" body={this.columnaCancelarVariosCfdis} style={{ width: '80px', textAlign: 'center' }} autoLayout={true} />
                    <Column header="Reexpedición" body={this.columnaReexpedicion} style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="ttCfdi.uuid" header="UUID" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="ttCfdi.total" body={this.columnaTotal} header="Total" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="ttCfdi.folio" header="Folio" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="ttCfdi.serie" header="Serie" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column body={this.columnaFechaCreacion} header="Fecha Creacion" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="tcEmisor.rfc" header="R.F.C. Emisor" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column field="tcReceptor.rfc" header="R.F.C. Receptor" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column body={this.columnaEstatus} header="Estatus" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                    <Column body={this.columnaTipoComprobante} header="Tipo Comprobante" style={{ width: '200px', textAlign: 'center' }} autoLayout={true} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />


                <Dialog header="Confirmación para cancelar" visible={modalCancelar} modal={true} style={{ width: '30vw' }} onHide={() => this.setState({ modalCancelar: false, cfdis: [] })}>

                    <div className="p-grid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="nombre">Cancelar comprobante: {cancelacionDto.uuid} ?</label>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="cancelacionDto.motivo">Motivo:</label>
                            <Dropdown name="cancelacionDto.motivo" itemTemplate={this.templateMotivos} autoWidth={true} appendTo={document.body} value={cancelacionDto.motivo} options={motivos} 
                                onChange={this.asignarValoresObjeto} placeholder="Selecciona un motivo de cancelacion" className={errores.folioSustitucion ? 'p-error' : ''}/>
                                {errores.motivo ? <div> <Message severity="error" text={errores.motivo} /> </div> : null}
                        </div>

                        <div className="p-col-12 p-md-12">
                            <label htmlFor="cancelacionDto.folioSustitucionustitucion"> Folio Sustitucion</label>
                            <InputText id="cancelacionDto.folioSustitucion" name="cancelacionDto.folioSustitucion" value={cancelacionDto.folioSustitucion || ''} onChange={this.asignarValoresObjeto} className={errores.folioSustitucion ? 'p-error' : ''} />
                            {errores.folioSustitucion ? <div> <Message severity="error" text={errores.folioSustitucion} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="nombre">Click en Salir: No cancelar</label>
                            
                        </div>
                        <div className="p-col-12 p-md-6">
                            <Button label="Cancelar Comprobante" onClick={this.enviarCancelar} className="teal-btn flat-btn" />
                        </div>
                        <div className="p-col-12 p-md-6">
                            <Button label="Salir" onClick={this.cerrarModalCancelacion} className="teal-btn flat-btn" />
                        </div>
                    </div>
                </Dialog>
                <Dialog header="Resultado de la cancelación" visible={mostrarModalResultado} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
                    <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
                        <Column field="uuid" header="UUID" />
                        <Column field="serie" header="Serie" />
                        <Column field="folio" header="Folio" />
                        <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
                    </DataTable>
                </Dialog>
                <Dialog header="Rexpedir Factura " visible={mostrarModalRexpedicion} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={dialogFooterExpedir} onHide={() => this.setState({ mostrarModalRexpedicion: false, tcReceptor: false })} >
                    <div className="p-grid p-fluid">

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="nombre">Rfc Receptor:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="rfc" name="tcReceptor.rfc" value={tcReceptor.rfc || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.rfc ? 'p-error' : ''} />
                            {erroresRequeridos.rfc ? <div> <Message severity="error" text={erroresRequeridos.rfc} /> </div> : null}
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="razonSocial">Razón Social:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="nombre" name="tcReceptor.nombre" value={tcReceptor.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                            {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                        </div>
                    </div>
                </Dialog>
            </div>

        );
    }
}